// @flow
import React from 'react';

import Form from 'components/Form';
import { useTranslation } from 'react-i18next'

type Props = {
    data: any,
    onChange: any => any
}
export default ({ data, isMultiple, onChange }: Props) => {
    
    const { t } = useTranslation();
    data["type"] = "prix"

    return (
        <React.Fragment>

            <Form
                form={[
                    { label: t("date"), attr: "date_enchere", type: "dateselector", size: { label: 150, field:150 }},
                    { label: t("interlocuteur"), attr: "source", type: "text", size: { label: 150, field:400 }},
                    
                    ...(isMultiple ? [
                        { label: t("numero_exemplaire"), attr: "multiple", type: "text", size: { label: 150, field:400 }},
                    ] : [] ),


                    { label: t("devise"), attr: 'devise_prix_de_vente', type: "select", options : [
                            { label: "Euros", value: "Euros"},
                            { label: "Dollars", value: "Dollars"},
                        ], size: { label: 150, field:150 }},
                    { label: t("prix"), attr: "prix_de_vente", type: "text", size: { label: 150, field:150 }},
                    { label: t("ville"), attr: "ville", type: "text", size: { label: 150, field:400 }},
                    { label: t("pays"), attr: 'pays', type: "select",
                        selectType: 'countries', size: { label: 150, field: 400 }
                    },
                    { label: t("remarques"), attr: "remarques", type: "text", size: { label: 150, field:400 }},
                ]}
                data={data}
                onChange={onChange}
            />

        </React.Fragment>

    )
}
